import "core-js/modules/es.string.trim-start.js";
export class Doc {
  constructor() {
    let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    this.content = [];
    this.indent = 0;
    if (this) this.args = args;
  }
  indented(fn) {
    this.indent += 1;
    fn(this);
    this.indent -= 1;
  }
  write(arg) {
    if (typeof arg === "function") {
      arg(this, {
        execution: "sync"
      });
      arg(this, {
        execution: "async"
      });
      return;
    }
    const content = arg;
    const lines = content.split("\n").filter(x => x);
    const minIndent = Math.min(...lines.map(x => x.length - x.trimStart().length));
    const dedented = lines.map(x => x.slice(minIndent)).map(x => " ".repeat(this.indent * 2) + x);
    for (const line of dedented) {
      this.content.push(line);
    }
  }
  compile() {
    var _this$content;
    const F = Function;
    const args = this === null || this === void 0 ? void 0 : this.args;
    const content = (_this$content = this === null || this === void 0 ? void 0 : this.content) !== null && _this$content !== void 0 ? _this$content : [""];
    const lines = [...content.map(x => "  ".concat(x))];
    // console.log(lines.join("\n"));
    return new F(...args, lines.join("\n"));
  }
}